import {Scene,Color,Mesh,SphereGeometry,MeshBasicMaterial,BackSide,PlaneGeometry,Float32BufferAttribute,Vector3} from 'three';

// A small studio map is baked once, then shared by clear toys. It introduces
// broad reflected lights and a dark lower hemisphere without more frame passes.
export function createJellyStudio(){
 const scene=new Scene();scene.background=new Color('#777c80');
 const shell=new SphereGeometry(20,32,16),colors=[];
 const low=new Color('#242b32'),high=new Color('#bfc6cc');
 for(let i=0;i<shell.attributes.position.count;i++){
  const y=shell.attributes.position.getY(i)/20;
  const blend=Math.max(0,Math.min(1,(y+.16)/.65));
  const color=low.clone().lerp(high,blend*blend*(3-2*blend));colors.push(color.r,color.g,color.b);
 }
 shell.setAttribute('color',new Float32BufferAttribute(colors,3));
 scene.add(new Mesh(shell,new MeshBasicMaterial({vertexColors:true,side:BackSide})));
 for(const [position,size,power] of [[[-5,7,6],[4,6],7],[[5,4,1],[2,5],4],[[0,6,-5],[5,3],6]]){
  const light=new Mesh(new PlaneGeometry(...size),new MeshBasicMaterial({color:new Color(power,power,power)}));
  light.position.set(...position);light.lookAt(new Vector3());scene.add(light);
 }
 return scene;
}
export function disposeJellyStudio(scene){scene.traverse(object=>{object.geometry?.dispose();object.material?.dispose();});}
